module.exports = __webpack_public_path__ + "static/stats2@2x-9fd26821fdf74d962ce819615d35cd3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/cabify/stats2@2x.jpg
// module id = 342
// module chunks = 3627797113349 20562973939449 33019919093843